import { useNavigate } from "react-router-dom";

export type BrandNameTheme = "dark" | "light";
export type BrandNameSize = "default" | "large";

interface BrandNameProps {
	theme?: BrandNameTheme;
	className?: string;
	navigateTo?: string;
	size?: BrandNameSize;
}

export function BrandName({
	theme = "dark",
	className = "",
	navigateTo,
	size = "default"
}: BrandNameProps) {
	const navigate = useNavigate();

	const textColorClass =
		theme === "dark" ? "text-primary-active" : "text-primary-accent";

	const sizeClasses =
		size === "large"
			? { job: "text-4xl", map: "text-4xl" }
			: { job: "text-xl", map: "text-xl" };

	const handleClick = () => {
		if (navigateTo) {
			navigate(navigateTo);
		}
	};

	return (
		<div
			className={`${navigateTo ? "cursor-pointer hover:opacity-80" : ""}  transition-opacity font-varela ${textColorClass} ${className}`}
			onClick={handleClick}
		>
			{/* Always side by side */}
			<div className="flex items-baseline whitespace-nowrap">
				<span className={`font-black ${sizeClasses.job}`}>Job</span>
				<span className={sizeClasses.map}>Map</span>
			</div>
		</div>
	);
}
